import { Component, forwardRef } from '@angular/core';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import * as moment from 'moment';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { IDatePickerDirectiveConfig } from 'ng2-date-picker';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DatePickerEditorComponent),
  multi: true
};

@Component({
  selector: 'swb-datepicker',
  templateUrl: './datepicker.component.html',
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})

export class DatePickerEditorComponent extends FormEditorBase implements ControlValueAccessor {
  private _onModelChanged: Function;

  public value: any;

  public config: IDatePickerDirectiveConfig = {
    locale: 'cs',
    showTwentyFourHours: true,
    format: 'YYYY-MM-DDTHH:mm:ss.sssZ',
    appendTo: 'body'
  };

  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  public registerOnTouched(fn: Function): void {
    // noop
  }

  public writeValue(value: any) {
    if (value) {
      this.value = moment(value);
    }
  }

  public onChange(event: any) {
    this.value = moment(event.target.value, 'DD.mm.yyyy').toISOString();
    this._onModelChanged(this.value);
  }

  constructor() {
    super();
  }
}
